import Config from "../config";
import React from "react";
import {useGlobal} from "reactn";

const Picture = ({user = {}, room}) => {

    let brand = useGlobal('brand')[0];

    if(room && room.isGroup){
        return <img className="picture" src={room.room_avatar} alt="Avatar Room"/>;
    }

    let firstName = user.firstName || "User";
    if (room && room.shieldedID){
        return <img className="picture" src={`${Config.url || ''}/api/images/${room?.shieldedID}/256/${brand}`} alt="Avatar User"/>;        
    }
    else
        return <div className="img">{firstName.substr(0,1).toUpperCase()}</div>;
};

export default Picture;
